import React, { useState } from "react";

const SearchBar = ({ onSearch }) => {
  const [term, setTerm] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    onSearch(term);
  };

  return (
    <form onSubmit={handleSubmit} className="flex gap-2">
      <div className="search-bar">
        <input
          type="text"
          className="border px-4 py-2 w-full"
          placeholder="Search YouTube..."
          value={term}
          onChange={(e) => setTerm(e.target.value)}
        />
        <button className="bg-blue-600 text-white px-4 py-2">Search</button>
      </div>
    </form>
  );
};

export default SearchBar;
